import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WizumenModel } from '../../wizumen-models';
import { Device } from 'projects/common/model/Device';

@Component({
  selector: 'wizumen-collapsed',
  template: `

        <div class="wizumen-detail-header flex">
          <span class="wizumen-detail-content flex justify-space-between align-center">
              <span class="wizumen-city -eva-3-bold">{{item.to}}</span>
                  <span *ngIf="item.booking_info" class="wizumen-booking-status-driver eva-3-driver {{layoutInfo}}">
                    <span class="driver-text">{{item.booking_info.description}}</span>
                  </span>
          </span>
          <wizumen-date-countdown class="wizumen-date-countdown" [item]="this.item" [isDesktop]="true"></wizumen-date-countdown>
        </div>

        <div class="wizumen-products-container">
          <div class="wizumen-products-content-container">
            <p class="eva-3-h5 wizumen-products-title">{{'wizumen.productsTitle' | translate}}</p>
            <div class="wizumen-products"
              [ngClass]="{'wizumen-V2': this.item.wizumen_v2}">
                <wizumen-product-icon *ngFor="let product of item.products" [product]="product" [isV2]="this.item.wizumen_v2"></wizumen-product-icon>
            </div>
          </div>
        </div>

        <div class="wizumen-xsell-container-content">
          <incentive-xsell-coupon [xSellBanner]="item.xsell_banner" [device]="device" [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"></incentive-xsell-coupon>
        </div>
  `,
  styleUrls: ['./wizumen-collapsed.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WizumenCollapsedComponent {
  @Input() item: WizumenModel;
  @Input() layoutInfo: string;
  @Input() device: Device;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId: string;

  constructor() { }
}
